import { render } from "./DocumentDisplayView.vue?vue&type=template&id=beba0764"
import script from "./DocumentDisplayView.vue?vue&type=script&lang=js"
export * from "./DocumentDisplayView.vue?vue&type=script&lang=js"

import "./DocumentDisplayView.vue?vue&type=style&index=0&id=beba0764&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__